import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";

const OnboardingCompleteModal = ({ open, setOpen }) => {
  const linkIframe =
    "https://kellyspecialty.qwilr.com/BaxRx-Dashboard-Onboarding-rU96T7R9RkiJ";

  const [loading, setLoading] = useState(true);

  const toggleModal = () => {
    setOpen(!open);
  };

  const handleIframeLoad = () => {
    setLoading(false);
  };

  return (
    <Modal size="xl" isOpen={open} backdrop="static" keyboard={false}>
      <ModalBody>
        {/* {loading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              height: "500px",
            }}
          >
            <div className="text-center">
              <Spinner
                style={{
                  width: "3rem",
                  height: "3rem",
                }}
                color="primary"
              />
            </div>
          </div>
        )} */}
        <iframe
          src={linkIframe}
          width="100%"
          // height="80vh"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="Onboarding"
          onLoad={handleIframeLoad}
          style={{ display: "block", minHeight: '80vh' }}
        ></iframe>
      </ModalBody>
      <ModalFooter>
        <Button disabled={loading} onClick={toggleModal} color="primary">
          Complete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OnboardingCompleteModal;
